import { ICustomerWalletDetails } from "api/types";
import Divider from "components/common/Divider";
import Text from "components/common/Text/Text";
import Widget from "components/common/Widget";
import * as React from "react";
import { Col, Row } from "react-grid-system";
import styled from "styled-components";
import SendCustomerWalletDetails from "./SendCustomerWalletDetails";

interface IProps {
  walletDetails: ICustomerWalletDetails;
  error: boolean;
  sending: boolean;
  errorMessage: string;
  isMessageSent?: boolean;
  sendCustomerWalletDetailsBySMS(): void;
}

const BlockchainWalletDetails: React.SFC<IProps> = ({
  walletDetails,
  isMessageSent,
  sendCustomerWalletDetailsBySMS,
  error,
  sending,
  errorMessage
}) => (
  <Row justify="center">
    <Col xs={12}>
      <Divider transparent />
      <Widget>
        <h4>My Address</h4>
        <div style={{ wordWrap: "break-word" }}>
          {walletDetails.accountAddress}
        </div>
        <br />
        <h4>Point Balance</h4>
        <div style={{ wordWrap: "break-word" }}>
          <b>
            {parseInt(walletDetails.accountAssetBalance, 0)}{" "}
            {walletDetails.assetSymbol}
          </b>{" "}
          ({walletDetails.assetName})
        </div>
        <br />
        <SendCustomerWalletDetails
          sendCustomerWalletDetailsBySMS={sendCustomerWalletDetailsBySMS}
          sending={sending}
        />
        <MessageSentNotification>
          {isMessageSent && <Text>Wallet info sent</Text>}
          {error && (
            <Text spaced error>
              {errorMessage}
            </Text>
          )}
        </MessageSentNotification>
        <Divider transparent />
      </Widget>
    </Col>
  </Row>
);

const MessageSentNotification = styled.div`
  display: inline-block;
  margin-left: 24px;
`;

export default BlockchainWalletDetails;



// WEBPACK FOOTER //
// ./src/screens/Main/edit-profile/blockchain/BlockchainWalletDetails.tsx